import React from "react";
import ReactDOM from "react-dom";
import SubsidyEmployeesTable from "../../components/allowanceTable/SubsidyEmployeesTable";
import {
  findCompanyDetail,
  findCompanyId,
} from "../../../../infrastructure/repository/company-repository";
import { findFreshEmployees } from "../../../../infrastructure/employees-cache";
import { findEmployeeFilter } from "../../../../infrastructure/employees-filter";
import {
  loadAllowance,
  getAllowance,
  addEmployeeId,
  defaultEmployeeAllowance,
} from "../../../../infrastructure/allowance-config-repository";
import { showErrorMessage } from "../../../commons/show-error-message";
import { addContextLog, logError } from "../../../../infrastructure/log";
import { translate } from "../../../../infrastructure/translate/localization";

class Employee {
  constructor({ id, internalId, nameAndSurnames, state }) {
    this.id = id;
    this.internalId = internalId;
    this.nameAndSurnames = nameAndSurnames;
    this.state = state;
  }
}

export function renderSubsidyEmployeesTable({
  employees,
  employeeIds,
  employeesItems,
  currentEmployees,
  currentPage,
  pageCount,
  mealDays,
  mealAmount,
  transportAmount,
  nurseryAmount,
  mealBenefit,
  transportBenefit,
  nurseryBenefit,
  model,
  recurrentSubsidy,
  alertId,
  generalParameters,
  countryISO2Code,
}) {
  const results = employees.map(
    (e) =>
      new Employee({
        id: e.id,
        internalId: e.internalId || "-",
        nameAndSurnames: `${e.name} ${e.surname}`,
        state: e.state,
      })
  );

  const target = document.getElementById("subsidy-employees-table-container");

  if (target) {
    ReactDOM.render(
      <SubsidyEmployeesTable
        currentPage={currentPage}
        employees={results}
        employeesItems={employeesItems}
        employeeIds={employeeIds}
        pageCount={pageCount}
        currentEmployees={currentEmployees}
        model={model}
        mealDays={mealDays}
        mealAmount={mealAmount}
        transportAmount={transportAmount}
        nurseryAmount={nurseryAmount}
        mealBenefit={mealBenefit}
        transportBenefit={transportBenefit}
        nurseryBenefit={nurseryBenefit}
        recurrentSubsidy={recurrentSubsidy}
        alertId={alertId}
        generalParameters={generalParameters}
        countryISO2Code={countryISO2Code}
      />,
      target
    );
  }
}

export async function displaySubsidyEmployees({
  fromSubsidyPage = false,
  model,
  mealBenefit,
  transportBenefit,
  nurseryBenefit,
  recurrentSubsidy = false,
  alertId = null,
  currentPage,
}) {
  try {
    const keyToFilter = ["internalId", "name", "surname", "legalId", "email"];

    const companyId = await findCompanyId();
    const { data } = await findCompanyDetail();
    const allEmployees = await findFreshEmployees({ companyId });
    const currentEmployees = allEmployees
      .filter(
        (e) =>
          e.modelId === model.id &&
          e.state !== "uploading" &&
          e.state !== "removed"
      )
      .filter(findEmployeeFilter({ forState: "subsidy", keys: keyToFilter }));

    // Set Allowance in memory repo
    if (fromSubsidyPage && model.subsidy) {
      loadAllowance(model.subsidy, currentEmployees);
    }

    const allowance = getAllowance();
    if (allowance.employeeIds.length === 0) {
      currentEmployees.map((e) => {
        addEmployeeId(e.id);
        return defaultEmployeeAllowance(e.id);
      });
    }

    // CustomPagination
    const pageSize = 15;
    const employeeCount = currentEmployees.length;
    const pageCount = Math.ceil(employeeCount / pageSize);

    let pageIndex = currentPage || 0;
    if (pageIndex > pageCount - 1) pageIndex = pageCount - 1;
    if (pageIndex < 0) pageIndex = 0;

    const employees = currentEmployees.slice(
      pageIndex * pageSize,
      (pageIndex + 1) * pageSize
    );
    const { employeeIds, employeesItems, generalParameters } = getAllowance();

    renderSubsidyEmployeesTable({
      employees,
      employeeIds,
      employeesItems,
      currentEmployees,
      currentPage: pageIndex,
      pageCount,
      mealDays: generalParameters.mealDays,
      mealAmount: generalParameters.mealAmount,
      transportAmount: generalParameters.transportAmount,
      nurseryAmount: generalParameters.nurseryAmount,
      mealBenefit,
      transportBenefit,
      nurseryBenefit,
      model,
      recurrentSubsidy,
      alertId,
      generalParameters,
      countryISO2Code: data.countryISO2Code,
    });

    addContextLog("info", "renderSubsidyEmployeesTable", "display-screen", {
      modelId: model.id,
      employeeIds,
    });
  } catch (e) {
    logError(e, `Error to displaySubsidyEmployees in model ${model.id}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
